import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24ImageG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M18.107 3.276a2.616 2.616 0 0 1 2.617 2.617v12.214a2.616 2.616 0 0 1-2.617 2.617H5.893a2.616 2.616 0 0 1-2.617-2.617V5.893a2.616 2.616 0 0 1 2.617-2.617zm-8.745 9.04-4.778 4.779v1.012c0 .723.586 1.309 1.309 1.309h12.214c.723 0 1.309-.586 1.309-1.309v-.663a1 1 0 0 1-.073-.045l-.082-.069-2.63-2.616-2.173 1.848a.654.654 0 0 1-.801.036l-.085-.072zm8.745-7.732H5.893c-.723 0-1.309.586-1.309 1.309v9.35L8.9 10.93a.655.655 0 0 1 .844-.07l.081.07 4.245 4.245 2.173-1.847a.655.655 0 0 1 .8-.036l.085.071 2.288 2.276V5.893c0-.723-.586-1.309-1.309-1.309m-1.882 2.18a1.224 1.224 0 1 1 .003 2.45 1.224 1.224 0 0 1-.003-2.451z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24ImageG$1 = Svg24ImageG;

export { Svg24ImageG$1 as default };
